import { useQuery } from '@apollo/client';
import { PortfolioEmail } from '@bakerweb/models';
import { useEffect, useState } from 'react';
import { GET_PORTFOLIO_EMAILS } from '../graphql/queries/getPortfolioEmails';

export const useGetPortfolioEmails = (variables: { portfolioCodes?: string[]; employeeEmail?: string } = {}) => {
  const [portfolioEmails, setPortfolioEmails] = useState<PortfolioEmail[]>([]);
  const { loading, error, data, refetch } = useQuery(GET_PORTFOLIO_EMAILS, {
    variables,
    skip:
      (!variables.portfolioCodes || variables.portfolioCodes.length === 0) &&
      (!variables.employeeEmail || variables.employeeEmail === ''),
    fetchPolicy: 'cache-first'
  });

  useEffect(() => {
    if (data && data.portfolioEmails) {
      setPortfolioEmails(data.portfolioEmails);
    }
  }, [data]);

  return { loading, error, portfolioEmails, refetch };
};
